import React from 'react';

const CardList = (props) => {
    const classes = `card-list fw-medium fs-sm list-unstyled${props.className ? ' ' + props.className : ''}`;
    return (
        <>
            {props.items &&
            <ul className={classes}>
                {props.items.map((item, index) => {
                    return <li className="m-0" key={index}>{item}</li>
                })}
            </ul>
            }
        </>

    );
};

export default CardList;

